<!--  -->
<template>
  <div class="payOption" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="content">
      <div class="box">
        <span style="font-size:14px;">筛选日期</span>
        <el-divider direction="vertical"></el-divider>
        <el-button
          class="daybtn"
          @click="yearBtn(0)"
          size="mini"
          :class="timeActive == 0 ? 'tagActive' : ''"
        >{{ nowYear }}全年</el-button>
        <el-button
          class="daybtn"
          @click="yearBtn(-1)"
          size="mini"
          :class="timeActive == -1 ? 'tagActive' : ''"
        >{{ nowYear - 1 }}全年</el-button>
        <el-button
          class="daybtn"
          @click="yearBtn(-2)"
          :class="timeActive == -2 ? 'tagActive' : ''"
          size="mini"
        >{{ nowYear - 2 }}全年</el-button>
        <el-date-picker
          size="mini"
          v-model="time"
          value-format="yyyy-MM-dd"
          value="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTime"
        ></el-date-picker>
        <el-button size="mini" type="info" @click="timeReset()" class="cz">重置</el-button>
      </div>
      <div class="box line">
        <span style="font-size:14px;margin-left:27px">地区</span>
        <el-divider direction="vertical"></el-divider>
        <button class="allbtn" @click="qyall()" :class="areaActive == -1 ? 'tagActive' : ''">全部</button>
        <el-checkbox-group
          v-model="qyChecked"
          style="display:inline-block;margin-right:40px;"
          v-for="(item, index) in countryList"
          :key="index"
        >
          <span class="group">
            <el-checkbox :label="item[0]" @change="handleAll(item[0])"></el-checkbox>
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-checkbox-group
                    v-model="country"
                    @change="dySelect($event, items.nfid)"
                    v-for="(items, index) in item[1]"
                    :key="index"
                  >
                    <el-checkbox :label="items.chinesecountry">
                      {{
                      items.chinesecountry
                      }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-checkbox-group>
        <div class="tagList">
          <el-tag v-for="tag in tags" :key="tag" closable @close="handleClose(tag)">{{ tag }}</el-tag>
        </div>
      </div>
      <div class="box hy" :class="foldActive ? '' : 'gao2'">
        <span style="font-size:14px;">行业</span>
        <el-divider direction="vertical"></el-divider>
        <button class="allbtn" @click="hyall()" :class="hyActive == -1 ? 'tagActive' : ''">全部</button>
        <el-checkbox-group v-model="hyChecked">
          <el-checkbox
            @change="hySelect($event)"
            v-for="item in toplist"
            :label="item"
            :key="item"
          >{{ item }}</el-checkbox>
        </el-checkbox-group>
        <span class="fold" @click="handleFold">
          {{ foldActive ? '展开' : '收起'
          }}
          <i
            :class="foldActive ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ></i>
        </span>
      </div>
      <div class="box gjc">
        <span style="font-size:14px;">关键词</span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleDel(tag)"
        >{{ tag }}</el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
          maxlength="6"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加关键词</el-button>
      </div>
      <div class="box">
        <span style="font-size:14px;">匹配方式</span>
        <el-divider direction="vertical"></el-divider>
        <el-button size="mini" @click="ppfs('1')" :class="ppActive == 1 ? 'tagActive' : ''">按标题匹配</el-button>
        <el-button size="mini" @click="ppfs('2')" :class="ppActive == 2 ? 'tagActive' : ''">按原文匹配</el-button>
        <!-- <div class="ppbtn">按标题匹配</div>
        <div class="ppbtn">按原文匹配</div>-->
      </div>
      <div class="box">
        <span style="font-size:14px;">价格区间</span>
        <el-divider direction="vertical"></el-divider>
        <el-input
          size="mini"
          placeholder="请输入金额"
          v-model="moneystart"
          @change="checkmoney"
          :min="0"
          style="width:150px"
          oninput="value=value.replace(/[^\d]/g,'')"
        >
          <span slot="suffix">万元</span>
        </el-input>至
        <el-input
          size="mini"
          :max="2147483647"
          placeholder="请输入金额"
          v-model="moneyend"
          @change="checkmoney"
          style="width:150px"
          oninput="value=value.replace(/[^\d]/g,'')"
        >
          <span slot="suffix">万元</span>
        </el-input>
      </div>
      <div class="box">
        <span style="font-size:14px;">采购单位</span>
        <el-divider direction="vertical"></el-divider>
        <el-input
          placeholder="请输入采购单位"
          v-model="cgdw"
          clearable
          style="width:500px;"
          size="small"
          maxlength="30"
        ></el-input>
      </div>
      <div style="margin-left:88px;margin-top:20px">
        <el-button class="qd" style="width:120px;" size="small" @click="nextStep">确定</el-button>
        <el-button style="width:120px" size="small" @click="allReset()" class="cz">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import tool from '../../tool/tool'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'payOption',
  components: {},
  data() {
    //这里存放数据
    return {
      areaActive: -1,
      hyActive: -1,
      toplist: [], //行业列表
      checkedType: [], //行业全选控制
      timeActive: 0, //时间按钮样式控制
      ppActive: 1, //匹配按钮样式控制
      countryList: [],
      country: [],
      time: [],
      moneyend: 0,
      moneystart: 0,
      foldActive: true, //行业展开收起样式控制
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      tags: [],
      cgdw: '', //采购单位
      nowYear: '', //当年
      hyChecked: [], //行业多选框集合
      qyChecked: [], //区域多选框集合
      gjc: null, //关键词
      theway: '1', //匹配方式
      all: [1], //
      tagTemp: [],
      paichuList: [],
      continent: [],
      uid: '',
      fullscreenLoading: false,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    allReset() {
      this.timeReset()
      this.qyall()
      this.hyall()
      this.dynamicTags = []
      this.ppfs('1')
      this.moneystart = 0
      this.moneyend = 0
      this.cgdw = ''
    },
    ppfs(val) {
      this.ppActive = val
      this.theway = val
    },
    timeReset() {
      this.timeActive = 0
      this.time = [tool.getYear('s', 0), tool.getYear('e', 0)]
    },
    yearBtn(val) {
      this.timeActive = val
      this.time = [tool.getYear('s', val), tool.getYear('e', val)]
    },
    paichu() {
      //用于删除区域查询中英文对应国家
      //筛选洲际国家列表
      let params = {}
      this.axios
        .get(API_1 + Global.paichu, { params: params })
        .then((res) => {
          this.paichuList = res.data.data
        })
        .catch((res) => {})
    },
    allCountry() {
      //筛选洲际国家列表
      let params = {}
      //Global.country
      this.axios
        .get(API_1 + Global.screenCountry, { params: params })
        .then((res) => {
          this.countryList = Object.entries(res.data.data)
          //this.temp = res.data.data
        })
        .catch((res) => {
          console.log(res)
        })
    },
    handleAll(val) {
      //全选洲际
      this.all = []
      let obj = {
        北美洲: '1',
        大洋洲: '2',
        非洲: '3',
        南美洲: '4',
        欧洲: '5',
        亚洲: '6',
      }

      if (this.qyChecked.length == 0) {
        this.areaActive = -1
        this.all = [1]
      } else {
        this.areaActive = 0
      }
      let temp = []
      this.qyChecked.map((val) => {
        temp.push(obj[val])
      })
      this.continent = temp
    },
    nextStep() {
      if (this.dynamicTags.length == 0) {
        this.$message({
          message: '请至少添加一个关键词',
          type: 'warning',
          offset: 100,
        })
      } else {
        this.fullscreenLoading = true
        if (this.moneystart == '' || this.moneystart == null) {
          this.moneystart = 0
        }
        if (this.moneyend == '' || this.moneyend == null) {
          this.moneyend = 0
        }
        let params = {
          date: this.time,
          all: this.all,
          country: this.tagTemp,
          continent: this.continent,
          lableall: this.hyChecked,
          keyword: this.dynamicTags,
          theway: this.theway,
          didbudget: [this.moneystart, this.moneyend],
          didcustome: this.cgdw,
          userid: this.uid,
        }
        this.axios
          .post(API_1 + Global.send, params)
          .then((res) => {
            this.fullscreenLoading = false
            if (res.data.status == 1) {
              this.$router.push({
                path: 'pay',
                query: { excelcode: res.data.data, num: res.data.msg },
              })
            } else if (res.data.status == 2) {
              this.$message({
                message: '抱歉，没有发现相应的数据，请换个筛选条件重试吧',
                type: 'warning',
                offset: 100,
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 100,
              })
            }
          })
          .catch((res) => {
            this.$message({
              message: '网络连接失败，请刷新重试',
              type: 'error',
              offset: 100,
            })
          })
      }
    },
    checkmoney(val) {
      // if (
      //   (this.moneystart == '' || this.moneystart == undefined) &&
      //   (this.moneyend == '' || this.moneyend == undefined)
      // ) {
      //   this.moneyShow = false
      // } else {
      //   this.moneyShow = true
      // }
    },
    handleDel(tag) {
      //删除排查词标签
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      //删除排查词标签
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      //排除词输入 失焦
      let inputValue = this.inputValue
      if (this.dynamicTags.length >= 5) {
        this.$message({
          message: '最多添加5个关键词',
          type: 'warning',
          offset: 100,
        })
      } else {
        if (inputValue) {
          this.dynamicTags.push(inputValue)
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleFold() {
      //行业收起展开控制
      this.foldActive = !this.foldActive
    },
    top() {
      //行业
      let params = {}
      this.axios
        .get(API_1 + Global.top, { params: params })
        .then((res) => {
          this.toplist = res.data.top
        })
        .catch((res) => {})
    },
    changeTime() {},
    handleClose(tag) {
      let name
      let tempList
      this.paichuList.forEach((item) => {
        if (item.chinesecountry == tag) {
          name = item.nfid
        }
      })

      tempList = this.country
      tempList.forEach((item, i) => {
        if (item == name) {
          tempList.splice(i, 1) // 从下标 i 开始, 删除 1 个元素
        }
      })
      let index = this.tagTemp.indexOf(name)
      this.tagTemp.splice(index, 1)
      this.country = tempList
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dySelect(val, name) {
      //勾选地域
      this.areaActive = 0
      this.all = []
      this.tagTemp.push(name)
      this.tags = this.country
    },
    hySelect() {
      //勾选行业
      if (this.hyChecked.length == 0) {
        this.hyActive = -1
      } else {
        this.hyActive = 0
      }
    },
    hyall() {
      this.hyChecked = []
      this.hyActive = -1
    },
    qyall() {
      //区域全部
      this.tags = []
      this.all = [1]
      this.qyChecked = []
      this.areaActive = -1
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.top()
    this.allCountry()
    this.yearBtn(0)
    this.paichu()
    this.uid = tool.getCookie('user')
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.nowYear = new Date().getFullYear() //本年
  },
  beforeCreate() {
    this.$emit('getStep', 1) //传出步骤条的参数
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {
    this.$emit('getStep', 1)
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.el-tag {
  margin-right: 10px;
}

.el-button {
  &:hover {
    background: #0f4d72;
    border: 1px solid #0f4d72 !important;
    color: #fff !important;
  }
}
.el-input__inner {
  margin: 0 10px;
}
.el-input__inner:focus {
  border-color: #0f4d72;
}
.el-range-editor.is-active:hover {
  border-color: #0f4d72;
}
.el-range-editor.is-active {
  border-color: #0f4d72;
}
.el-dropdown-menu {
  height: 450px;
  overflow-x: scroll;
  width: 180px;
}
.tagActive {
  background: #0f4d72;
  // padding: 5px 10px;
  border: 1px solid #0f4d72 !important;
  color: #fff !important;

  // margin: 3px 0;
}
.allbtn {
  margin-right: 20px !important;
  width: 75px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  color: #666;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #eee;
  &:hover {
    background: #0f4d72;
    border: 1px solid #0f4d72 !important;
    color: #fff !important;
  }
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: middle;
}
.el-divider--vertical {
  background: #0f4d72;
  width: 2px;
  opacity: 0.5;
  margin: 0 15px;
}
.payOption {
  text-align: left;

  .content {
    width: 1200px;
    margin: 20px auto 0;
    border-radius: 6px;
    background: #fff;
    padding: 0 30px 30px;
    box-sizing: border-box;
    /deep/.qd {
      background: #0f4d72;
      border: 1px solid #0f4d72;
      color: #fff;
      &:hover {
        background: #105e8c;
        border: 1px solid #0f4d72;
      }
    }
    .gjc {
      margin-left: 14px;
    }
    .gao2 {
      height: auto !important;
    }
    .hy {
      vertical-align: middle;
      margin-left: 28px;
      position: relative;
      overflow: hidden;
      height: 35px;
      line-height: 40px;
      background: #fff;

      .fold {
        position: absolute;
        top: 18px;
        right: -45px;
        width: 100px;
        font-size: 14px;
        color: #0f4d72;
        cursor: pointer;
      }
      .el-checkbox-group {
        width: 890px;
        display: inline-block;
        vertical-align: top;
      }
    }
    .line {
      padding: 20px 0px 10px !important;
      /deep/.el-checkbox-group {
        display: block;
      }
      /deep/ .el-tag {
        margin-bottom: 15px;
      }
    }
    .box {
      //height: 60px;
      border-bottom: 1px dotted #eee;
      //line-height: 60px;
      //margin-left: 40px;
      padding: 20px 0;
      /deep/.is-active {
        border-color: #0f4d72;
      }
      /deep/.el-checkbox__inner:hover {
        border-color: #0f4d72;
      }
      /deep/ .is-checked {
        .el-checkbox__label {
          color: #0f4d72;
        }
        .is-checked {
          .el-checkbox__inner {
            background-color: #0f4d72;
            border-color: #0f4d72;
          }
        }
      }
      /deep/.el-checkbox-group {
        .group {
          .is-checked {
            .el-checkbox__label {
              color: #0f4d72;
            }
            .is-checked {
              .el-checkbox__inner {
                background-color: #0f4d72;
                border-color: #0f4d72;
              }
            }
          }
        }
      }
      .el-tag {
        background: #e7edf1;
        color: #333;
        border: 0;
        /deep/.el-tag__close {
          color: #333;
          &:hover {
            background: #fff;
          }
        }
      }
      /deep/.cz {
        background: #0f4d72;
        color: #fff;
        border: 1px solid transparent;
        &:hover {
          background: #105e8c;
        }
      }
      /deep/.el-input__suffix {
        top: 5px;
      }
      /deep/.el-input__inner:focus {
        border-color: #0f4d72;
      }
      .el-input-group__append {
        padding: 0 24px;
        button {
          &:hover {
            background: #105e8c;
          }
          i {
            font-size: 20px;
          }
        }
      }
      /deep/.el-input-number {
        &:hover {
          border-color: #0f4d72;
        }
      }
      /deep/.el-input--mini {
        &:hover {
          border-color: #0f4d72;
        }
      }
      .ppbtn {
        margin-right: 10px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
      .tagList {
        margin: 10px 0 10px 87px;
        .el-tag {
          margin-right: 10px;
          background: #e7edf1;
          color: #333;
          border: 0;
          /deep/.el-tag__close {
            color: #333;
            &:hover {
              background: #fff;
            }
          }
        }
      }
      .daybtn {
      }
    }
  }
}
</style>
